export default __webpack_public_path__ + "static/media/IMG-20240822-WA0018.7c9e9ad8.jpg";